// src/config/constants.js
// Centralized configuration constants

// Gas fee in PGT smallest units (2 decimals: 100 = 1.00 PGT)
export const GAS_FEE_PER_TX = Number(process.env.REACT_APP_GAS_FEE || 100);

// PGT token decimals
export const PGT_DECIMALS = Number(process.env.REACT_APP_PGT_DECIMALS || 2);

// Cache durations (ms)
export const CACHE_EXPIRY_EVENTS = 5 * 60 * 1000;    // 5 minutes
export const CACHE_EXPIRY_TICKETS = 3 * 60 * 1000;   // 3 minutes

// Notification auto-hide durations (ms)
export const NOTIFICATION_DURATION_SHORT = 5000;
export const NOTIFICATION_DURATION_LONG = 8000;

// Network configs
export const NETWORKS = {
  8453: {
    chainName: 'Base Mainnet',
    rpcUrls: ['https://mainnet.base.org'],
    nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
    blockExplorerUrls: ['https://basescan.org'],
    explorerTxUrl: 'https://basescan.org/tx/',
  },
  84532: {
    chainName: 'Base Sepolia',
    rpcUrls: ['https://sepolia.base.org'],
    nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
    blockExplorerUrls: ['https://sepolia.basescan.org'],
    explorerTxUrl: 'https://sepolia.basescan.org/tx/',
  },
};

// XP values
export const XP_VALUES = {
  TICKET_PURCHASE: 50,
  BATCH_PURCHASE_PER_TICKET: 20,
  BATCH_THRESHOLD: 3,
  FIRST_PURCHASE: 100,
  REFERRAL: 75,
  CHECK_IN: 30,
};

// Contract addresses (from env)
export const CONTRACTS = {
  PGT: process.env.REACT_APP_PGT_ADDRESS,
  EVENT_TICKET: process.env.REACT_APP_EVENT_TICKET_ADDRESS,
  SIMPLE_SWAP: process.env.REACT_APP_SIMPLE_SWAP_ADDRESS,
};
